import React from 'react';
import { Link } from 'react-router-dom';
import { Check } from 'lucide-react';
import { useSiteData } from '../../context/SiteDataContext';

const DepollutionSection = () => {
  const { pageContent } = useSiteData();
  const c = pageContent?.depollution || {};

  return (
    <section className="min-h-screen w-full bg-black flex items-center" data-testid="depollution-section">
      <div className="w-full grid grid-cols-1 lg:grid-cols-2">
        <div className="relative h-[40vh] sm:h-[50vh] lg:h-screen order-2 lg:order-1">
          <img src={c.bgImage || 'https://images.unsplash.com/photo-1486262715619-67b85e0b08d3?w=1200'} alt="Solutions dépollution EGR FAP AdBlue" className="absolute inset-0 w-full h-full object-cover" />
          <div className="absolute inset-0 bg-gradient-to-r from-transparent to-black/50 lg:bg-gradient-to-l lg:from-black lg:via-transparent lg:to-transparent" />
        </div>
        <div className="flex items-center order-1 lg:order-2 py-12 sm:py-16 lg:py-0">
          <div className="w-full max-w-xl mx-auto px-4 sm:px-6 lg:px-12">
            <span className="text-red-500 text-xs sm:text-sm font-medium uppercase tracking-[0.2em]">{c.category || 'Dépollution'}</span>
            <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-white mt-3 sm:mt-4 mb-4 sm:mb-6 leading-tight">
              {c.title || 'Solutions'} <span className="text-red-500">{c.titleAccent || 'EGR, FAP, AdBlue'}</span>
            </h2>
            <p className="text-white/60 text-sm sm:text-base lg:text-lg leading-relaxed mb-4 sm:mb-6">{c.desc1 || ''}</p>
            <p className="text-white/60 text-xs sm:text-sm lg:text-base leading-relaxed mb-6 sm:mb-8">{c.desc2 || ''}</p>
            <div className="space-y-3 sm:space-y-4 mb-8 sm:mb-10">
              {(c.features || []).map((item, index) => (
                <div key={index} className="flex items-center gap-3 sm:gap-4">
                  <div className="w-7 h-7 sm:w-8 sm:h-8 rounded-full bg-red-600 flex items-center justify-center flex-shrink-0">
                    <Check size={14} className="text-white sm:hidden" /><Check size={16} className="text-white hidden sm:block" />
                  </div>
                  <span className="text-white font-medium text-xs sm:text-sm lg:text-base">{item}</span>
                </div>
              ))}
            </div>
            <Link to={c.ctaLink || '/reprogrammation'} data-testid="depollution-cta" className="group inline-flex items-center gap-3 bg-red-600 hover:bg-red-700 text-white px-6 sm:px-8 py-3 sm:py-4 rounded-full font-medium transition-all duration-300 text-sm sm:text-base">
              <span>{c.ctaText || 'Demander un diagnostic'}</span>
              <svg className="w-4 h-4 sm:w-5 sm:h-5 group-hover:translate-x-1 transition-transform" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" /></svg>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default DepollutionSection;
